const STEP_ACTIVE_CLASS = 'process-block__step--is-active';

const STEP_HOOK = '[js-hook-process-step]';

class processBlock {
    constructor(element) {
        this.element = element;
        this.processSteps = [...this.element.querySelectorAll(STEP_HOOK)];

        this.bindEvents();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.processSteps.forEach(step => {
            step.addEventListener('click', e => {
                this.addActiveClass(e);
            });
        });
    }

    addActiveClass(e) {
        this.processSteps.forEach(step => {
            step.classList.remove(STEP_ACTIVE_CLASS);
        });

        e.currentTarget.classList.add(STEP_ACTIVE_CLASS);
    }
}

export default processBlock;
